import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        backgroundColor: "#fff", 
        color: "#000", 
        textAlign: "center", 
        p: 2, 
        width: "100%", 
        mt: "auto" ,
        position: "fixed",
        bottom: 0,
      }}
    >
      <Typography variant="body2">© 2025 JSSISH. All Rights Reserved.</Typography>
    </Box>
  );
};

export default Footer;
